const App = () => <h1>Welcome to Neet</h1>;

export default App;
